'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import SvgRefresh from '@common/icon/SvgRefresh';
import { useEffect } from 'react';
import { ResponsiveDialog } from '@/components/organism/ResponsiveDialog';
import { BREAKPOINTS } from '@/constants';
import { useMediaQuery } from '@/hooks/useMediaQuery';
interface FilterDrawerShellProps {
  isOpen: boolean;
  onReset: () => void;
  onApply: () => void;
  onClose: () => void;
  children: React.ReactNode;
}
export function FilterDrawerShell(t0) {
  const $ = _c(18);
  const {
    isOpen,
    onReset,
    onApply,
    onClose,
    children
  } = t0;
  const isDesktop = useMediaQuery(BREAKPOINTS.DESKTOP, true);
  let t1;
  let t2;
  if ($[0] !== isDesktop || $[1] !== isOpen || $[2] !== onClose) {
    t1 = () => {
      if (isDesktop && isOpen) {
        onClose();
      }
    };
    t2 = [isDesktop, isOpen, onClose];
    $[0] = isDesktop;
    $[1] = isOpen;
    $[2] = onClose;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  if (isDesktop) {
    return null;
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SvgRefresh className="size-14" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== onReset) {
    t4 = <div className="flex justify-end"><Button type="button" theme="sub-text" dimensions="H32" className="gap-4 p-0 font-700 text-Gray-600 typo-body4" onClick={onReset}>{t3}초기화</Button></div>;
    $[6] = onReset;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== onApply) {
    t5 = <Button className="w-full" onClick={onApply}>적용 할게요</Button>;
    $[8] = onApply;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== children || $[11] !== t4 || $[12] !== t5) {
    t6 = <div className="flex flex-col gap-24 pb-32">{t4}{children}{t5}</div>;
    $[10] = children;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== isOpen || $[15] !== onClose || $[16] !== t6) {
    t7 = <ResponsiveDialog opened={isOpen} onClose={onClose} ariaLabel={"\uAC80\uC0C9 \uD544\uD130"} drawerType="bottom">{t6}</ResponsiveDialog>;
    $[14] = isOpen;
    $[15] = onClose;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}